module.exports = __webpack_public_path__ + "img/poweredby-01.b5f992d7.svg";